export default Object.freeze({
  Authentication: 1,
  Admin: 2,
  Auth: 3,
  Environment: 4,
  Process: 5,
  Role: 6,
  User: 7,
});
